module.exports = __webpack_public_path__ + "static/media/floor_s2.a8d2283d.png";